import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HrDirective } from './hr.directive';

export { HrVerticalAlign } from './hr.directive';

@NgModule({
  declarations: [HrDirective],
  exports: [HrDirective],
  imports: [CommonModule]
})
export class HrModule {}

export * from './hr.directive';
